import React from "react";
import { motion } from "framer-motion";
import { CheckIcon, ShieldCheckIcon, SparklesIcon } from "lucide-react";
import { Reveal, Eyebrow, goToCheckout, TrustBadges } from "./ui";
import { heroMockup, PRICE_CURRENT, PRICE_OLD, SAVINGS } from "./data";
const includes = ["6 tomos completos", "3 bonos incluidos", "Acceso inmediato", "Actualizaciones futuras"];
export function Offer() {
  return <section id="oferta" className="w-full scroll-mt-16 bg-[#f4f8fd] px-4 py-12 sm:px-8 sm:py-24" data-id="element-156" data-mp="tzwjlong7gjo">
      <div className="mx-auto max-w-xl" data-id="element-157" data-mp="p1bgnhgtairj">
        <Reveal className="text-center" data-id="element-158" data-mp="13wre7wglowso">
          <Eyebrow data-id="element-159" data-mp="13xsr86h6ftd1">Tu acceso completo</Eyebrow>
          <h2 className="font-serif-display text-[1.9rem] font-semibold leading-[1.08] text-[var(--ink)] sm:text-4xl" data-id="element-160" data-mp="yxxzk0pkuzqx">
            Todo el sistema para acompañar con más calma.
          </h2>
        </Reveal>

        <Reveal delay={0.1} data-id="element-161" data-mp="2add71yfexa0a">
          <div className="mt-7 overflow-hidden rounded-[1.75rem] bg-white shadow-[0_28px_65px_-34px_rgba(23,50,77,0.55)] sm:mt-10 sm:rounded-[2.25rem]" data-id="element-162" data-mp="2ac1sd3kfihue">
            <div className="relative overflow-hidden bg-[var(--ink)] px-5 pb-6 pt-5 text-center sm:px-10 sm:pb-8 sm:pt-7" data-id="element-163" data-mp="pml6bh9bn9ao">
              <div className="pointer-events-none absolute -left-12 top-4 h-32 w-32 rounded-full bg-[#2d74e8]/35 blur-3xl" data-id="element-164" data-mp="zhvc8g2uc0tq" />
              <div className="pointer-events-none absolute -right-10 bottom-0 h-28 w-28 rounded-full bg-[#59ad7a]/30 blur-3xl" data-id="element-165" data-mp="13iynsqduvap5" />

              <div className="relative flex items-center justify-center gap-2" data-id="element-166" data-mp="6vk8wxnunlt8">
                <span className="rounded-full bg-white/10 px-3 py-1 text-[10px] font-extrabold uppercase tracking-[0.14em] text-white/90" data-id="element-167" data-mp="btc2rx821i02">
                  Oferta de lanzamiento
                </span>
                <span className="rounded-full bg-[#f4c54b] px-2.5 py-1 text-[10px] font-extrabold text-[#5b470d]" data-id="element-168" data-mp="kmp2pj4jdjvn">
                  Ahorrás {SAVINGS}
                </span>
              </div>

              <motion.img src={heroMockup} alt="Mega Biblioteca para TDAH y Autismo Infantil" className="relative mx-auto mt-4 h-36 w-auto rounded-2xl border-2 border-white/85 object-contain shadow-[0_22px_36px_-18px_rgba(0,0,0,0.85)] sm:mt-5 sm:h-52" animate={{
              y: [0, -4, 0]
            }} transition={{
              duration: 4.5,
              repeat: Infinity,
              ease: "easeInOut"
            }} loading="lazy" data-id="element-169" data-mp="3o8wfivaom1t1" />
              <p className="relative mt-3 text-xs font-semibold text-white/75 sm:text-sm" data-id="element-170" data-mp="cg38tkd7l8q7">
                Pequeños Pasos, Grandes Logros™
              </p>
            </div>

            <div className="px-4 pb-5 pt-5 text-center sm:px-8 sm:pb-8 sm:pt-7" data-id="element-171" data-mp="lhb55ww5zzhn">
              <div className="flex items-center justify-center gap-2" data-id="element-172" data-mp="lf866nd1aw0s">
                <SparklesIcon className="h-4 w-4 text-[var(--accent)]" aria-hidden data-id="element-173" data-mp="heejfxbbvn9h" />
                <p className="text-xs font-extrabold uppercase tracking-[0.14em] text-[var(--accent)]" data-id="element-174" data-mp="1wvewswfa5bjj">
                  Incluye hoy
                </p>
              </div>

              <ul className="mt-3 grid grid-cols-2 gap-2 text-left sm:mt-5 sm:gap-3" data-id="element-175" data-mp="20e47hhnkdykc">
                {includes.map(item => <li key={item} className="flex min-h-[48px] items-center gap-2 rounded-xl border border-[#e2edf8] bg-[#f8fbff] px-2.5 py-2 sm:min-h-[54px] sm:rounded-2xl sm:px-3" data-id="element-176" data-mp="25fbirqox1fvr">
                    <span className="flex h-5 w-5 flex-none items-center justify-center rounded-full bg-[#dff1e5] text-[var(--accent-green)]" data-id="element-177" data-mp="2j556u6sljw4f">
                      <CheckIcon className="h-3 w-3" aria-hidden data-id="element-178" data-mp="2o36smzheq9jl" />
                    </span>
                    <span className="text-[10px] font-bold leading-tight text-[var(--ink)] sm:text-xs" data-id="element-179" data-mp="29eakz3j9iyji">{item}</span>
                  </li>)}
              </ul>

              <div className="my-5 border-t border-dashed border-[#d7e3ef] sm:my-7" data-id="element-180" data-mp="3249b729711pr" />

              <p className="text-sm font-medium text-[var(--muted)]" data-id="element-181" data-mp="36ups4wc835gv">Accedé al pack completo por</p>
              <div className="mt-1 flex items-end justify-center gap-2" data-id="element-182" data-mp="1j6egytmx791g">
                <span className="mb-1 text-sm font-semibold text-[#a9b5c1] line-through sm:text-base" data-id="element-183" data-mp="1j4bfndgbhthf">{PRICE_OLD}</span>
                <p className="font-serif-display text-[2.8rem] font-semibold leading-none tracking-[-0.04em] text-[var(--ink)] sm:text-6xl" data-id="element-184" data-mp="1988g8fcuo8y6">
                  {PRICE_CURRENT}
                </p>
              </div>
              <p className="mt-2 text-xs font-bold text-[var(--accent-green)]" data-id="element-185" data-mp="21wmbwoggut6k">
                Pago único · Sin suscripción · Para siempre
              </p>

              <motion.button onClick={goToCheckout} whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="mt-5 flex w-full items-center justify-center gap-2 rounded-2xl bg-[var(--accent)] px-5 py-4 text-base font-extrabold text-white shadow-[0_16px_36px_-12px_rgba(41,111,232,0.6)] transition-colors hover:bg-[#245dc3] focus:outline-none focus-visible:ring-4 focus-visible:ring-[var(--accent)]/30 sm:mt-7 sm:py-5 sm:text-lg" data-id="element-186" data-mp="1wyktm5qv6xw5">
                Quiero acceder ahora
                <SparklesIcon className="h-5 w-5" aria-hidden data-id="element-187" data-mp="2s64qm0g22zrj" />
              </motion.button>

              <div className="mt-4 flex items-center justify-center gap-2 text-xs font-semibold text-[var(--muted)]" data-id="element-188" data-mp="2x5q0h5wrksj1">
                <ShieldCheckIcon className="h-4 w-4 text-[var(--accent-green)]" aria-hidden data-id="element-189" data-mp="325vkbzwslaqk" />
                Garantía de 7 días, sin complicaciones
              </div>
              <TrustBadges className="mt-4" compact data-id="element-190" data-mp="3b5ikkidscai1" />
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}